module.exports = __webpack_public_path__ + "faq/img/away.197d7d04.png";